import React, {useEffect, useState} from "react";
import {getContext, getContextSilent} from "../redux_slices/contextSlice";
import {useDispatch, useSelector} from "react-redux";
import {ErrorPage1} from "../pages/ErrorPage/ErrorPage1";
import {LayoutSplashScreen} from "../../_metronic/layout";
import {sendDataLayer} from "../util/tagmanager";
import {setExternalToken, setToken} from "../redux_slices/authenticationSlice";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import LoginWrapper from "../pages/Authentication/LoginWrapper";
import ChallengesComponent from "../pages/Authentication/ChallengesComponent";
import {useHistory} from "react-router-dom";
import {Modal} from "react-bootstrap";

const AuthGate = ({children}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    const authenticationSelector = useSelector(state => state.authentication);
    const contextSelector = useSelector(state => state.context);
    const contextStatus = useSelector(state => state.context.status);
    const contextChallenges = useSelector(state => state.context?.challenges);

    const [showSplashScheen, setShowSplashScheen] = useState(true);
    const [showChallengesScreen, setShowChallengesScreen] = useState(false);
    const [isUnknown, setIsUnknown] = useState(false);

    useEffect(() => {
        window.title = "Winnow";
    }, []);

    useEffect(function manageTokenFromQueryURL() {
        if (contextStatus.type === "idle") {
            const urlParams = new URLSearchParams(window.location.search);
            const from = urlParams.get("from");
            const token = urlParams.get("token");
            if (token && token.length) {
                if (from === "external" && authenticationSelector.externalToken !== token) {
                    dispatch(setExternalToken(token));
                    dispatch(setToken(null));
                    history.push("/");
                } else if (authenticationSelector.token !== token) {
                    dispatch(setToken(token));
                }
            }
            const error = urlParams.get("error");
            if (error) {
                Swal.fire({icon: "error", text: t(error)}).then(() => {
                    urlParams.delete("error");
                });
            }
            dispatch(getContext()).then(() => {
                if (contextSelector.credential?.credential_id) {
                    sendDataLayer(
                        {
                            event: "session_login",
                        },
                        {context: contextSelector},
                    );
                }
            });
        } else {
            if (contextChallenges && contextChallenges.length) {
                setShowChallengesScreen(true);
            } else {
                setShowChallengesScreen(false);
            }
        }
    }, [contextSelector]);

    useEffect(() => {
        // if (!contextSelector.challenges || !contextSelector.challenges.length) {
        dispatch(getContextSilent());
        // }
    }, [authenticationSelector.token]);

    useEffect(() => {
        if (contextStatus.type === "succeeded") {
            sendDataLayer(
                {
                    event: "context_refresh",
                },
                {context: contextSelector},
                false,
            );
            setShowSplashScheen(false);
        } else if (["idle", "loading"].includes(contextStatus.type)) {
            setShowSplashScheen(true);
        } else if (contextStatus.type === "failed") {
            setIsUnknown(true);
        }
    }, [contextStatus]);

    if (isUnknown === true) {
        return <ErrorPage1 />;
    }
    if (showChallengesScreen === true && !authenticationSelector.externalToken) {
        return (
            <LoginWrapper>
                <ChallengesComponent />
            </LoginWrapper>
        );
    }
    if (showSplashScheen === false) {
        if (showChallengesScreen === true && authenticationSelector.externalToken) {
            return (
                <>
                    <Modal
                        show={true}
                        backdrop="static"
                        keyboard={false}
                        style={{overlay: {zIndex: 2000}}}
                    >
                        <ChallengesComponent />
                    </Modal>
                    {children}
                </>
            );
        }
        return children;
    }
    return <LayoutSplashScreen />;
};

export default AuthGate;
